import React from 'react'

function AITechSupport() {
    return (
        <div>
            technical troubleshooting page
        </div>
    )
}

export default AITechSupport
